export const CHANGE_APP_STATUS = 'CHANGE_APP_STATUS';

export const CHANGE_NOTIFICATION_INFO = 'CHANGE_NOTIFICATION_INFO';

export const CHANGE_MODAL_STATUS = 'CHANGE_MODAL_STATUS';
export const CHANGE_MODAL_CONTENT = 'CHANGE_MODAL_CONTENT';
